import { render } from "./RemoteCardCode.vue?vue&type=template&id=b16a0788&scoped=true"
import script from "./RemoteCardCode.vue?vue&type=script&lang=js"
export * from "./RemoteCardCode.vue?vue&type=script&lang=js"

import "./RemoteCardCode.vue?vue&type=style&index=0&id=b16a0788&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b16a0788"]])

export default __exports__